import type { Language, CategoryType } from '@/types/index';
import { categoriesApi } from '@/lib/api';
import { useOptimizedQuery } from './useOptimizedQuery';

export function useCategories(language: Language) {
  return useOptimizedQuery({
    queryKey: ['categories', language],
    queryFn: () => categoriesApi.getAll(language),
    tier: 'updatable',
  });
}

export function useCategoriesByType(language: Language, type: CategoryType) {
  return useOptimizedQuery({
    queryKey: ['categories', language, type],
    queryFn: () => categoriesApi.getByType(language, type),
    tier: 'updatable',
  });
}

export function useHomepageCategories(language: Language) {
  return useOptimizedQuery({
    queryKey: ['categories', language, 'homepage'],
    queryFn: () => categoriesApi.getHomepage(language),
    tier: 'updatable',
  });
}
